<template>
  <canvas :id="idcanvas" :width="width?width:'auto'" :height="height? height : 'auto'"></canvas>
</template>
<script>
import Chart from "chart.js";
import graph from "@/helpers/graph";
import ChartDataLabels from "chartjs-plugin-datalabels"
// import graph from "@/helpers/graph";

export default {
  props: {
    datagraph: {
      type: Object,
    },
    cambio: Number,
    width: Number,
    height: Number
  },
  data() {
    return {
      idcanvas: "",
      chart: null,
      config: null,
      colorbase: [
        "#293462",
        "#f76262",
        "#216583",
        "#aee7e8",
        "#28c3d4",
        "#fbc99d",
        "#ed1250",
        "#10ddc2",
        "#042f4b",
        "#15b7b9",
        "#f57170",
        "#248ea9",
      ],
    };
  },
  created() {
    this.idcanvas = Math.random().toString(36).substr(2, 9);
  },
  mounted() {
    if (this.datagraph.data) {
      this.render(this);
    }
  },
  methods: {
    render(_this) {
      // const _this = this;
      Chart.defaults.global.defaultFontFamily = "'Montserrat', sans-serif"; // con esto configuramos el tipo de letra
      Chart.defaults.global.tooltips.backgroundColor = "rgba(45, 64, 89, 0.9)"; // con esto se configura el fondo del tooltip
      Chart.plugins.unregister(ChartDataLabels);

      let datasets;
      if (_this.datagraph.typeGraphic === "horizontalBar") {
        datasets = _this.datagraph.data.datasets
      } else {
        datasets = _this.sortData(_this.datagraph);
      }
      const ctx = document.getElementById(_this.idcanvas);
      ctx.getContext("2d");
      // ctx.height = 220;
      _this.config = {
        // The type of chart we want to create
        type: _this.datagraph.typeGraphic,

        // The data for our dataset
        data: {
          labels: _this.datagraph.labels,
          datasets: datasets,
        },
        // Configuration options go here
        options: _this.datagraph.options,
      };

      if (_this.datagraph.typeGraphic === "radar") {
        _this.config.plugins = [{
          id: 'customPlugin',
          beforeDatasetsDraw: (chart, args, options) => {
            const {ctx, width, chartArea: {top, bottom}, scale} = chart
            ctx.save()
            ctx.strokeStyle = 'rgba(0,0,0,0.84)'
            ctx.lineWidth = 2
            ctx.moveTo(scale.xCenter, bottom - 16)
            ctx.lineTo(scale.xCenter, top + 40)
            ctx.stroke()

            ctx.moveTo(width - scale.yCenter - 16, scale.yCenter)
            ctx.lineTo(scale.yCenter + 16, scale.yCenter)
            ctx.stroke()
          }
        }]
      } else if (_this.datagraph.typeGraphic === "horizontalBar") {
        _this.config.plugins = [ChartDataLabels]

        // Create the plugin for target
        let originalLineDraw = Chart.controllers.horizontalBar.prototype.draw;
        Chart.helpers.extend(Chart.controllers.horizontalBar.prototype, {
          draw: function () {
            originalLineDraw.apply(this, arguments);

            let chart = this.chart;
            let ctx = chart.chart.ctx;

            let index = chart.config.options.lineAtIndex;
            if (index) {

              let xaxis = chart.scales['x-axis-0'];
              let yaxis = chart.scales['y-axis-0'];

              let x1 = xaxis.getPixelForValue(index);
              let y1 = yaxis.top;

              let x2 = xaxis.getPixelForValue(index);
              let y2 = yaxis.bottom;

              ctx.save();
              ctx.beginPath();
              ctx.moveTo(x1, y1);
              ctx.strokeStyle = "#510087";
              ctx.lineTo(x2, y2);
              ctx.stroke();

              ctx.restore();
            }
          }
        });
      }

      if (_this.chart) {
        // si la grafica ya existia la destruimos
        _this.chart.destroy();
      }
      _this.chart = new Chart(ctx, this.config);
    },
    decimals(arr) {
      const newArr = [];
      for (let val of arr) {
        if (val !== null) {
          newArr.push(Number(val.toFixed(1)));
        } else {
          newArr.push(val)
        }
      }
      return newArr;
    },
    sortData(datagraph) {
      const datasets = [];
      const _this = this;
      datagraph.data.forEach(function (k, v) {
        const d = {
          fill: false,
        };
        d.label = datagraph.series[v];
        d.borderColor = datagraph.colors[v];
        d.backgroundColor = graph.hexToRgbAcultura(datagraph.colors[v]);
        d.borderWidth = 2;
        d.data = _this.decimals(k);

        if (v === 1) {
          d.borderDash = [10, 5]
        }
        if (datagraph.datasetOverride[v]) {
          d.type = datagraph.datasetOverride[v].type;
        }
        datasets.push(d);
      });
      return datasets;
    },
  },
  watch: {
    cambio(newv, oldv) {
      if (this.datagraph.data) {
        this.render(this);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Graphcultura.vue